const bodyText = document.getElementById("bodyText");

if (bodyText) {
  TextFill("#bodyText", {
    maxFontPixels:48,
    minFontPixels: 12,
  });
};
